export function getPatentApplicationNumber(application: {
  epoApplicationNumber?: string | null
  euipoApplicationNumber?: string | null
} | null | undefined) {
  return application?.epoApplicationNumber || application?.euipoApplicationNumber || undefined
}
